import { useCallback } from 'react';

const useLocalStorage = () => {
  const get = useCallback((key: string) => {
    try {
      let localData = localStorage.getItem(key) ?? '{}';
      if (localData) {
        try {
          localData = JSON.parse(localData);
        } catch (err) {
          // do nothing
        }
      }
      return localData;
    } catch (err) {
      return null;
    }
  }, []);

  const set = useCallback((key: string, value: any) => {
    try {
      if (typeof value !== 'object') {
        localStorage.setItem(key, value);
      } else {
        const localData: any = get(key);
        let localValue = {
          ...(localData ?? {}),
          ...(value ?? {}),
        };
        localValue = JSON.stringify(localValue);
        localStorage.setItem(key, localValue);
      }
    } catch (err) {
      //
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const remove = useCallback((key: string) => {
    localStorage.removeItem(key);
  }, []);

  return { get, set, remove };
};

export default useLocalStorage;
